export const GROUPS = [
  {
    id: "invitations",
    title: "Wedding Invitations",
    eyebrow: "The suite starts here",
    intro: "Letterpress on 100% cotton, real hot-foil, deboss, white ink on dark stock, velvety soft-touch or ultra-thick 32pt — every invitation is printed to order on Mohawk, Colorplan and cotton stocks and proofed by a real prepress designer before it prints.",
    match: (n) => /invitation/i.test(n) && !/envelope/i.test(n),
  },
  {
    id: "save-the-dates",
    title: "Save the Dates, RSVP & Details Cards",
    eyebrow: "Before and inside the envelope",
    intro: "Save-the-date cards that set the tone six to nine months out, plus RSVP and details cards printed on the same stock and colour as the invitation so every enclosure matches.",
    match: (n) => /save the date|rsvp|details card/i.test(n),
  },
  {
    id: "day-of",
    title: "Day-of Stationery",
    eyebrow: "Ceremony & reception",
    intro: "Programs, menus, place cards and table numbers that carry the invitation design through to the tables — order once the RSVPs are in and we'll match your suite exactly.",
    match: (n) => /program|menu|place card|table number|seating|sign/i.test(n),
  },
  {
    id: "envelopes",
    title: "Envelopes & Guest Addressing",
    eyebrow: "The first thing guests see",
    intro: "A7, A6 and A4 invitation envelopes, foil-printed return addresses and variable-data guest addressing straight from your spreadsheet — no hand-lettering, no label stickers.",
    match: (n) => /envelope|addressing/i.test(n),
  },
];

export function groupProducts(products) {
  const used = new Set();
  const groups = GROUPS.map((g) => {
    const items = products.filter((p) => !used.has(p.product_id) && g.match(p.name || ""));
    items.forEach((p) => used.add(p.product_id));
    return { ...g, items };
  });
  const rest = products.filter((p) => !used.has(p.product_id));
  if (rest.length) groups.push({ id: "more", title: "More Wedding Pieces", eyebrow: "Also in the suite", intro: "", items: rest });
  return groups.filter((g) => g.items.length);
}

const FINISHES = [
  [/letterpress/i, "Letterpress"],
  [/foil stamp|foil wedding envelopes/i, "Hot Foil"],
  [/digital foil/i, "Digital Foil"],
  [/deboss/i, "Deboss"],
  [/white ink/i, "White Ink"],
  [/soft touch/i, "Soft Touch"],
  [/ultra thick|32pt/i, "32pt Ultra Thick"],
  [/addressing/i, "Variable Data"],
  [/envelope/i, "Envelopes"],
];

export function finishLabel(name = "") {
  const hit = FINISHES.find(([re]) => re.test(name));
  return hit ? hit[1] : "Full Color Digital";
}

export const WEDDING_POSTS = [
  { slug: "foil-stamped-invitations-houston", title: "Foil-stamped wedding invitations — timeline, foils and shipping" },
  { slug: "shipping-foil-invitations-without-damage", title: "Shipping foil invitations without damage — a printer's guide" },
  { slug: "rush-foil-stamping-letterpress-embossing-plates-and-deadlines", title: "Can foil, letterpress or embossing be rushed? Plates, dies and deadlines" },
];
